import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 407 图片遮罩
 */

export default class EventMaskPic extends EventBase {
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '0,0,0', '20', '0', '0']
  }

  // #region 事件内关键属性参数
  /**
   * 图片ID
   */
  get PicId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set PicId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 变色颜色（255，255，255）
   */
  get MaskColor() {
    return this.Parameter?.[1] || ''
  }
  set MaskColor(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 是否数值指定不透明（1:是，0：否）
   */
  get OpacityValueorNot() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set OpacityValueorNot(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  /**
   * 不透明度或数值ID
   */
  get OpacityValue() {
    return parseInt(this.Parameter?.[3] ?? '')
  }
  set OpacityValue(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  /**
   * 事件ID
   */
  Code = EventID.MaskPic

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
  get Description() {
    return this.Parameter?.[4] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  public GetParameter() {
    return this.Parameter
  }
  // #endregion
}
